import {Pipe, PipeTransform} from '@angular/core';
import {FrequencyLabelMap, FrequencyStrMap} from "../../domain/enums/occupation-freq.enum";

@Pipe({
  name: 'frequency',
  standalone: true
})
export class FrequencyPipe implements PipeTransform {

  transform(value: unknown, ...args: unknown[]): unknown {
    if(!value) { return value; }

    const frequency = FrequencyStrMap.get(<string>value);
    return frequency ? FrequencyLabelMap.get(frequency) : value;
  }

}
